// js/setup/ui-setup-food-create-panel.js
import { setSetupStage, persistSetupStage } from './setup-stage-manager.js';
import { createPanelController } from '../shared/ui-panel-base.js';
import { setFoods } from '../state-manager.js';
import { createClientFoods, loadClientFoods } from '../requests/foods.js';
import {
  pendingFoods,
  addFood,
  resetFoodForm,
  renderFoodPreview,
  populateProfilesSelect
} from './ui-setup-food-form.js';

export const createFoodPanel = createPanelController('setup-food-create', {
  onOpen: () => {
    pendingFoods.length = 0;
    resetFoodForm();
    renderFoodPreview();
    populateProfilesSelect();
  },
  onClose: () => {
    pendingFoods.length = 0;
  },
});

document.getElementById('setup-add-food')?.addEventListener('click', () => {
  const name = document.getElementById('setup-food-name')?.value;
  const weight = document.getElementById('setup-food-weight')?.value;
  const barcode = document.getElementById('setup-food-barcode')?.value;
  const selected = document.getElementById('setup-food-profile-ids')?.selectedOptions;
  const profileIds = Array.from(selected).map(opt => opt.value);

  addFood({ name, weight, barcode, profileIds });
  renderFoodPreview();
  resetFoodForm();
});

document.getElementById('setup-submit-foods')?.addEventListener('click', async () => {
  if (pendingFoods.length === 0) return alert('Add some food first.');

  const payload = pendingFoods.map(f => ({
    name: f.name,
    weight: f.weight,
    barcode: f.barcode,
    profile_ids: f.profileIds,
  }));

  try {
    const result = await createClientFoods(payload);
    if (result.success) {
      const updated = await loadClientFoods();
      setFoods(updated);
      setSetupStage({ foodsCreated: true });
      createFoodPanel.close();
      createFoodPanel.onSubmitSuccess?.();
    } else {
      alert('Failed to create foods.');
    }
  } catch (err) {
    console.error('[FoodCreatePanel] Error:', err);
    alert('Something went wrong.');
  }
});
